import { INew_TableAction } from '@lla-platform/core/core-data-access'
import { IFluidsRequest } from '../../interfaces/fluids.interface'

export class GetFluidsSummary {
  static readonly type = '[Fluids] Get Fluids Summary'
  constructor(public payload: IFluidsRequest) {}
}

export class GetFluidsList {
  static readonly type = '[Fluids] Get Fluids List'
  constructor(public info: INew_TableAction) {}
}
